<template>
  <v-main>
    <div>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-main>
</template>

<script>
export default {
  metaInfo () {
    return {
       title: 'ZERA -' + this.$route.name
    }
  }
}
</script>


<style>
#core-view {
 margin-bottom: 50px;
}
</style>
